var map = {
	"./Xsign.png": 201,
	"./account.png": 699,
	"./add-icon.png": 4801,
	"./aggregate.png": 4487,
	"./arrow-back.png": 2741,
	"./arrow-left.png": 8123,
	"./arrow.png": 3021,
	"./asset_icon.png": 3656,
	"./avatar.png": 4211,
	"./black-bound-solid.png": 9406,
	"./black-dashboard-icon.png": 9828,
	"./black-discovery-icon.png": 7338,
	"./black-edit-pencil.png": 2990,
	"./black-eye.png": 323,
	"./black-farmer-icon.png": 6457,
	"./black-inventory-icon.png": 1060,
	"./black-logistics-icon.png": 4171,
	"./black-mill-icon.png": 2416,
	"./black-profit-input.png": 5383,
	"./black-purchase.png": 7643,
	"./black-settings-icon.png": 6283,
	"./black-tag-solid.png": 8902,
	"./bound-solid.png": 2352,
	"./carbon_information-filled.png": 99,
	"./card-arrow-right.png": 5135,
	"./community.png": 4197,
	"./countryside-woman-out-field.png": 8872,
	"./dashboard-icon.png": 1906,
	"./dashboard_arrow.png": 7976,
	"./dashboard_arrow_2.png": 6555,
	"./dashboard_icon.png": 7416,
	"./decline_icon.png": 3666,
	"./delete-icon.png": 8895,
	"./discovery-icon.png": 564,
	"./discovery_icon.png": 5278,
	"./dropdown_icon.png": 3407,
	"./edit-icon.png": 1168,
	"./edit-pencil.png": 1868,
	"./email.png": 5738,
	"./excel-icon.png": 893,
	"./eye.png": 4353,
	"./farmer-icon.png": 4407,
	"./farmer_icon.png": 1645,
	"./field-agent.png": 4846,
	"./filter-icon.png": 4318,
	"./green-eye.png": 5851,
	"./header-logo.png": 3415,
	"./home.png": 773,
	"./inventory-icon.png": 9542,
	"./inventory_icon.png": 3660,
	"./location_icon.png": 913,
	"./lock.png": 7641,
	"./login_background.png": 3198,
	"./logistic_icon.png": 9072,
	"./logistic_icons.png": 2041,
	"./logistics-icon.png": 5325,
	"./logistics.png": 1967,
	"./logo.png": 3153,
	"./logout.png": 9134,
	"./make-default.png": 9006,
	"./map.png": 12,
	"./mask.png": 1492,
	"./mill-icon.png": 9482,
	"./no-data.png": 4064,
	"./notification.png": 5741,
	"./outbound_icon.png": 1766,
	"./pencil.png": 8643,
	"./phone-icon.png": 9974,
	"./plus.png": 528,
	"./profile_picture.png": 782,
	"./profit-input.png": 457,
	"./purchase.png": 4617,
	"./releaf-logo-white.png": 6391,
	"./releaf-logo.png": 4439,
	"./releaf_logo.png": 3673,
	"./search-icon.png": 4520,
	"./search.png": 8679,
	"./settings-icon.png": 4501,
	"./supply_icon.png": 185,
	"./tabler_layout-dashboard.png": 7570,
	"./tag-solid.png": 9064,
	"./target-icon.png": 2917,
	"./trend-down.png": 4342,
	"./trend-orange.png": 5480,
	"./trend-up.png": 9593,
	"./wallet_icon.png": 8275,
	"./x-icon.png": 7310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;